import { gql } from 'apollo-boost';

export const newEmailTemplate = gql`
  mutation newEmailTemplate(
      $name: String!,
      $body: String!,
      $subject: String!
  ) {
    newEmailTemplate(
      name: $name,
      body: $body,
      subject: $subject
  ) {
      success
      id
    }
  }
`;
